export const NavbarVariant = Object.freeze({
  Default: "default",
  Guest: "guest",
  Free: "free",
  Ghost: "ghost",
  Logo: "logo",
});
